<div class="kl-report">
  <header class="kl-report__header">
    <div class="kl-report__header-left">
      <h2 class="kl-report__filters-title">{{ 'filters' | translate }}</h2>
      <p-button
        class="kl-report__start-btn"
        [label]="startButtonKey() | translate"
        size="small"
        (onClick)="onStartClick()" />
    </div>
    <div class="kl-report__header-right">
      <p-button
        type="button"
        class="kl-report__toggle"
        [text]="true"
        [icon]="filterPanelOpen() ? 'ph ph-caret-left' : 'ph ph-list'"
        [attr.aria-label]="'filters' | translate"
        (onClick)="toggleSidebar()" />
      <h1 class="kl-report__report-title">{{ reportTitle() }}</h1>
    </div>
  </header>

  <div class="kl-report__body">
    <aside class="kl-report__sidebar">
      <div class="kl-report__sidebar-inner">
        @if (showReportType()) {
          <div class="kl-report__report-type">
            <p-panel class="kl-rfp-panel" [toggleable]="true" [collapsed]="true" toggler="header">
              <ng-template pTemplate="header">
                <span class="kl-rfp-panel-header-title">{{ 'report_type' | translate }}</span>
              </ng-template>
              <div class="kl-rfp-field">
                <p-select
                  inputId="kl-rpt-type"
                  [options]="reportTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  [ngModel]="reportType()"
                  (ngModelChange)="onReportTypeSelect($event)"
                  appendTo="body"
                  class="w-full">
                  <ng-template let-item pTemplate="item">{{ item.label | translate }}</ng-template>
                  <ng-template let-item pTemplate="selectedItem">
                    @if (item) {
                      {{ item.label | translate }}
                    }
                  </ng-template>
                </p-select>
              </div>
            </p-panel>
          </div>
        }
        <div class="kl-report__filters-host">
          <ng-content select="[kl-report-filters]" />
          @if (filtersLoading()) {
            <div class="kl-report__sidebar-overlay">
              <kl-loader />
            </div>
          }
        </div>
      </div>
    </aside>
    <main class="kl-report__main">
      <div class="kl-report__main-inner">
        @if (showResults()) {
          <ng-content select="[kl-report-results]" />
        }
        @if (loading()) {
          <div class="kl-report__main-overlay">
            <kl-loader size="lg" />
          </div>
        }
      </div>
    </main>
  </div>
</div>
